import { useAppSelector } from '@legacyApp/hooks/store/useAppSelector';
import { shallowEqual } from 'react-redux';

export const useDropdownActiveSelector = (id: string) =>
	useAppSelector((state) => state.dropdown.active[id], shallowEqual);
